import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const FinishSeasonDialog = ({ open, seasonName, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Finalizar temporada</DialogTitle>
    <DialogContent>
      <Alert severity="warning" sx={{ mb: 1 }}>
        Essa ação encerra a temporada e impede novas rodadas nela.
      </Alert>
      <Typography variant="body2" color="text.secondary">
        Confirma finalizar <strong>{seasonName || "esta temporada"}</strong>?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
      <Button color="error" variant="contained" onClick={onConfirm}>
        Finalizar temporada
      </Button>
    </DialogActions>
  </Dialog>
);

export default FinishSeasonDialog;

